import { QueryList } from '@angular/core';
import { LineWidthPanel } from 'markerjs2';
import { RadioComponent } from '../../../../../Common/Forms/components/Radio/radio.component';


export class ChartAnnotationLineWidthPanel extends LineWidthPanel {

    radioGroup: HTMLDivElement;
    currentLineWidth: number;
    radioComponents: QueryList<RadioComponent>;

    constructor(
        title: string,
        widths: number[],
        currentWidth?: string,
        icon?: string,
        radioGroup?: HTMLDivElement,
        radioComponents?: QueryList<RadioComponent>
    ) {
        const lineWidth = parseInt(currentWidth, 10);
        super(
            title,
            widths,
            lineWidth,
            icon
        );
        this.radioGroup = radioGroup;
        this.currentLineWidth = lineWidth;
        this.radioComponents = radioComponents;
    }

    getUi(): HTMLDivElement {
        this.radioComponents.forEach(x => x.writeValue(this.currentLineWidth));
        this.radioGroup.style.display = 'flex';
        return this.radioGroup;
    }
}
